module.exports = __webpack_public_path__ + "static/buttonAriaLabel-652eb5a3876ea53e8ef5b3aacc775d62.png";